export default class ErrorResponse {
    isError: boolean;
    messageCode: string;
    message: string;

    constructor(messageCode: string, message: string) {
        this.isError = true;
        this.messageCode = messageCode;
        this.message = message;
    }
}



// WEBPACK FOOTER //
// ./src/models/ErrorResponse.ts